import { formatNumber } from "../../store/Session/helper/UnitConversions";
import { ConvertedData } from "../../store/Session/SessionModel";

interface Props {
	shot: ConvertedData;
	round?: number;
	fixed?: boolean;
}

// KWSA-38: `formatNumber` drops trailing zeros, so 125 renders as "125". Metrics
// that must always show their decimals (Apex, Side Carry) pass fixed, which keeps
// the thousands separator but pins the fraction digits — 125 renders as "125.0".
const formatFixed = (value: number, decimals: number): string =>
	value.toLocaleString(undefined, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});

const ShotValueKey = ({ shot, round = 1, fixed = false }: Props) => {
	if (shot.valueString === "---") {
		return <span>---</span>;
	}
	const rounded = parseFloat(shot.value.toFixed(round));
	const displayValue = shot.side ? Math.abs(rounded) : rounded;
	const text = fixed
		? formatFixed(displayValue, round)
		: formatNumber(displayValue, round);
	return <span>{text + shot.side}</span>;
};
export default ShotValueKey;
